import instance from "../axios";
import * as types from "../actionTypes";

export const sendDebugMessage = (state: any) => {
  console.log("sendDebugMessage");
  //   ChromeCast.quit();
  return (dispatch: any) => {
    return instance
      .post(`v1/debug/email`, state)
      .then((res) => {
        console.log(res);
        //console.log(res.data);
        //   dispatch(actions.setQuiz(res.data));
      })
      .catch((err) => {
        console.log(err);
      });
  };
};

export const loadDebugState = (state: any) => {
  return (dispatch: any) => {
    let newState = JSON.parse(state);
    console.log(newState);
    return dispatch({ type: types.LOAD_DEBUG_STATE, payload: newState });
  };
};
